import Vue from 'vue'
import Router from 'vue-router'
import MainPage from '@/components/MainPage'
import Assist from '@/components/Assist'
import Files from '@/components/Files'
import ModContent from '@/components/ModContent'
import Authors from '@/components/Authors'


Vue.use(Router)

export default new Router({
    mode: 'history',    
    routes: [
        {
            path: '/',
            name: 'Home',
            component: MainPage
        },
        {
            path: '/assist',
            name: 'Assist',
            component: Assist
        },         
        {
            path: '/authors',
            name: 'Authors',
            component: Authors
        }, 
        {
            path: '/content',
            name: 'ModContent',
            component: ModContent
        },        
        {
            path: '/content/:option',
            name: 'ModContent',
            component: ModContent
        },  
        {
            path: '/content/:option/:content',
            name: 'ModContent',
            component: ModContent
        }, 
        {
            path: '/files',
            name: 'Files',
            component: Files
        },
        {
            path: '/files/:option',
            name: 'Files',
            component: Files
        },
        {
            path: '*',
            name: '404',
            component: MainPage
        },
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js